const storeStatements = require('./storeStatements')

module.exports = {
  storeStatements,
}
